import { Box } from "@mui/material";
import HeroSection from "./HeroSection";
import React from "react";
import Working from "./Working";
import HowRegister from "./HowRegister";
import Support from "./Support";
import Faq from "./Faq";
import user from "../../../asset/images/user-profile.svg";
import best from "../../../asset/images/best.svg";
//import email from "../../../asset/images/email.svg";
import whatsapp from "../../../asset/images/whatsapp-1.svg";
import Convinient from "./Convinient";
import Footer from "../../Footer";

export default function LandingPageProf(){
    

    const landingPageuser={
        heroHeader:"Add your Header here",
        heroSecond:"Add your Header here",
		heroThird:"Add your Header here",
        workingFirst:"Add your text here",
        workingSecond:"Add your text here",
        workingThird:"Add your text here",
        howReg:{
            firstTitle:"Add your Header here",
            firstSub:"Add your text here",
            secondTitle:"Add your Header here",
            secondSub:"Add your text here",
            thirdTitle:"Add your Header here",
            thirdSub:"Add your text here",
        },
		    supportList:[
      "Free Website Migration",
      "Free Website Migration",
      "Free Website Migration",
      "Free Website Migration",
      "Free Website Migration",

	]
 }
    const landingPageProf={
        heroHeader:"בעל מקצוע? עבודות חדשות מחכות להצעת המחיר שלך",
        heroSecond:"לקוחות מפרסמים עבודות, ואתה בוחר לאילו מכרזים להיכנס, רואה את מיקום ההצעה שלך ויכול לשפר אותה כל עוד המכרז פתוח.",
		heroThird:"ההרשמה והגשת ההצעות בחינם. משלמים 14.90 ש״ח רק אם זכית והלקוח כבר אישר שהוא רוצה להתקדם איתך.",
        workingFirst:"קבלת התראות באפליקציה, בוואטסאפ ובמייל",
        workingSecond:"נותנים ומשפרים הצעה בכל זמן, כל עוד המכרז פתוח",
        workingThird:"רואים את מיקום ההצעה ושומרים על שליטה במחיר",
        howReg:{
            firstTitle:"הגדר פרופיל",
            firstSub:"צור פרופיל באתר שלנו. בפרופיל תגדיר את העיסוק ואזורי השירות שלך. תוכל גם לכתוב כמה מילים על עצמך.",
            secondTitle:"קבל התראות",
            secondSub:"ברגע שלקוח יפרסם מכרז עם בקשה לעבודה שמתאימה לעיסוק ולאזור השירות שלך, אתה תקבל מיד הודעה באפליקציה או בוואטסאפ ובמייל, תוכל להכנס לאתר ולתת הצעת מחיר לעבודה הזו.",
            thirdTitle:"תתחיל לעבוד!",
            thirdSub:"המכרז הסתיים וזכית? הלקוח מאשר תחילה שהוא רוצה להתקדם איתך. רק לאחר האישור אתה מחליט אם לשלם 14.90 ש״ח ולקבל את פרטי הלקוח.",
        },
		
		   supportList:[
      "ממשק ידידותי, פשוט ונוח.",
      "מקבלים התראות על עבודות רלוונטיות, גם אם אתם על הספה...",
      "רק אתה בוחר לאילו עבודות להגיש הצעה.",
      "רואים את מיקום ההצעה ויכולים לשפר אותה כל עוד המכרז פתוח.",
      "משלמים רק אחרי שזכית והלקוח אישר שהוא רוצה להתקדם איתך.",

	]
}

    const faqUserQuestions = [
        {
          question: 'כמה השירות הזה עולה?',
          answer: 'This is the answer to the first question. It can be a long answer that will be displayed within the elevated section.',
        },
        {
          question: 'How does the second question work?',
          answer: 'This is the answer to the second question. It can also be a lengthy answer that fits within the elevated section.',
        },
        {
            question: 'How does the second question work?',
            answer: 'This is the answer to the second question. It can also be a lengthy answer that fits within the elevated section.',
          },
          {
            question: 'How does the second question work?',
            answer: 'This is the answer to the second question. It can also be a lengthy answer that fits within the elevated section.',
          },
      ];
      const faqProfQuestions = [
        {
          question: 'מה זה בידאיט?',
          answer: 'בידאיט היא פלטפורמה למציאת בעלי מקצוע בצורת מכרז - באופן פשוט, נוח והוגן. כל אחד יכול לפתוח מכרז, מוגבל בזמן, על עבודה שהוא מעוניין שיבצעו אותה עבורו. כל בעל מקצוע יכול להצטרף ולתת הצעת מחיר ולזכות במכרז. ',
        },
        {
          question: 'כמה השירות הזה עולה?',
          answer: 'ההרשמה וההשתתפות במכרזים הן בחינם. רק כאשר הצעת בעל המקצוע זוכה והלקוח מאשר את העסקה, בעל המקצוע יכול לבחור אם הוא מעוניין לקבל את פרטי הלקוח (שכבר הסכים ואישר את העסקה) תמורת 14.90 ש״ח. התשלום עבור העבודה עצמה נעשה ישירות בין הלקוח לבעל המקצוע ואינו עובר דרך Bidit.',
        },
        {
            question: 'איפה רואים את המכרזים?',
            answer: 'ברגע שלקוח מפרסם מכרז באתר שלנו, המכרז מופיע בדף הראשי (דף הבית) שלנו. ',
          },
          {
            question: 'איך נותנים הצעת מחיר למכרז?',
            answer: 'מרגע שמכרז עולה לאתר, בעל המקצוע יכול לתת עליו הצעת מחיר. כנס למכרז, לחץ על "תן הצעה". אין מגבלה לגובה ההצעה שתוכל לתת. אין מגבלה על כמות ההצעות שתוכל לתת. עם זאת, במידה וכבר קיימת הצעה, תוכל להציע מחיר שקטן ב-10 ש"ח לפחות מהמחיר המוצע. לדוגמא: אם קיימת הצעה על סכום של 500 ש"ח, תוכל להציע הצעה חדשה מסכום של 490 ש"ח ומטה. לא תוכל להציע הצעה על סכום של 495 ש"ח.',
          },
          {
		    question: 'איך רואים את תוצאות המכרז?',
		    answer: 'כשמכרז מסתיים, הלקוח ובעל המקצוע הזוכה מקבלים הודעה. הלקוח בוחר ומאשר את ההצעה תחילה. לאחר אישור הלקוח, בעל המקצוע מאשר את העסקה ומשלם 14.90 ש״ח כדי לקבל את פרטי הלקוח שכבר הסכים להתקדם.',
          },
		  {
		    question: 'יש לי עוד שאלות...',
            answer: 'תוכל לעיין בסעיף "שאלות נפוצות" באתר שלנו, בתחתית המסך. יש שם תשובות להמון שאלות שיכול להיות שמעניינות אותך. לא קיבלת תשובה? תוכל ליצור איתנו קשר, גם בתחתית המסך תחת "דיגיטל ויצירת קשר".',
          },
		  
      ];

      const conviDataUser=[
        {
            text:"Add your text here",
            image:user,
        },
        {
            text:"Add your text here",
            image:whatsapp,
        },
        {
            text:"Add your text here",
            image:best,
        }
      ]
      const conviDataProf=[
        {
            text:"יוצרים פרופיל",
            image:user,
        },
        {
            text:"מקבלים התראות על מכרזים באפליקציה, בוואטסאפ ובמייל",
            image:whatsapp,
        },
        {
            text:"נכנסים למכרזים באתר, נותנים הצעות מחיר וזוכים",
            image:best,
        }
      ]
      let prof={current:true}
    return (
      <Box
        dir="rtl"
        sx={{
          minHeight: "100vh",
          overflowX: "hidden",
          background: "linear-gradient(180deg, #f7fbfe 0%, #ffffff 22%, #ffffff 100%)",
        }}
      >
        <Box
          sx={{
            width: { xs: "calc(100% - 24px)", sm: "92%", md: "88%", lg: "1180px" },
            maxWidth: "1180px",
            mx: "auto",
            pt: { xs: 1, md: 2 },
            pb: { xs: 3, md: 5 },
            fontFamily: "Assistant",
          }}
        >
        <HeroSection prof={prof.current} text={prof.current?landingPageProf:landingPageuser}/>
        <Working text={prof.current?landingPageProf:landingPageuser}/>
        <HowRegister text={prof.current?landingPageProf:landingPageuser} prof={prof.current}/>
        <Support text={prof.current?landingPageProf:landingPageuser} prof={prof.current}/>
        <Faq faq={prof.current?faqProfQuestions:faqUserQuestions} prof={prof.current}/>
        <Convinient conviData={prof.current?conviDataProf:conviDataUser} prof={prof.current}/>
    
        </Box>
        <Footer/>
      </Box>
    )
}
